import React from "react";
import { cn } from "@ndd/ui";
import type { MetricEnvelope, MetricName } from "../../../../../shared/metrics";
import {
  METRIC_LABELS,
  MISSING_MINIMUM_FLAG,
  MISSING_MINIMUM_LINK_LABEL,
  metricSublabel,
  periodColumns,
  showsMissingMinimumFlag,
  type FunctionalFormLink,
  type MetricCadence,
} from "../../../lib/metrics-display";
import { MetricChip } from "./metric-chip";
import { MetricDefinitionPopover } from "./metric-definition-popover";

export function PeriodTableRow({
  name,
  envelope,
  functionalFormLink,
}: {
  name: MetricName;
  envelope: MetricEnvelope;
  cadence: MetricCadence;
  anchor: string;
  startDate: string | undefined;
  functionalFormLink?: FunctionalFormLink;
}) {
  const label = METRIC_LABELS[name];
  const columns = periodColumns(envelope);

  return (
    <tr className="border-t border-border">
      <th scope="row" className="px-[10px] py-2 text-left align-top font-normal">
        <div className="flex items-center gap-2">
          <span className="text-title-sm leading-[18px] text-foreground">{label}</span>
          <MetricDefinitionPopover label={label} envelope={envelope} />
        </div>
        <span className="block text-body leading-[15px] text-muted-foreground">
          {showsMissingMinimumFlag(envelope) ? (
            <>
              {MISSING_MINIMUM_FLAG}
              {functionalFormLink
                ? functionalFormLink(MISSING_MINIMUM_LINK_LABEL)
                : MISSING_MINIMUM_LINK_LABEL}
            </>
          ) : (
            metricSublabel(envelope)
          )}
        </span>
      </th>
      {columns.map((column, index) => (
        <td
          key={column.label}
          className={cn(
            "px-[10px] py-2 text-right text-sm tabular-nums text-foreground",
            index === 0 && "bg-muted font-semibold"
          )}
        >
          {column.value}
        </td>
      ))}
      <td className="px-[10px] py-2 align-middle">
        <MetricChip chip={envelope.chip} />
      </td>
    </tr>
  );
}
